import "@/App.css";
import { ThemeProvider } from "next-themes";
import { LanguageProvider } from "./context/LanguageContext";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Chatbot from "./components/Chatbot";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import LegalNotice from "./pages/LegalNotice";

// Scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

// Inject noindex for policy pages
function PolicyMeta() {
    const { pathname } = useLocation();
    const isPolicyPage = [
        "/politica-de-privacidad",
        "/privacy-policy",
        "/politica-de-cookies",
        "/cookie-policy",
    ].includes(pathname);

    useEffect(() => {
        let tag = document.querySelector('meta[name="robots"][data-policy]');
        if (isPolicyPage) {
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "robots");
                tag.setAttribute("data-policy", "true");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", "noindex, nofollow");
        } else {
            if (tag) tag.remove();
        }
    }, [isPolicyPage]);

    return null;
}

function AppShell() {
    return (
        <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
            <ScrollToTop />
            <PolicyMeta />
            <TopBar />
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/en" element={<Home />} />
                <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/politica-de-cookies" element={<CookiePolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/aviso-legal" element={<LegalNotice />} />
                <Route path="/legal-notice" element={<LegalNotice />} />
                <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <WhatsAppButton />
            <Chatbot />
            <Toaster />
        </div>
    );
}

function App() {
    return (
        <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
            <LanguageProvider>
                <BrowserRouter>
                    <AppShell />
                </BrowserRouter>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
